//------------------------------------------------------------------------------
// Node Modules ---------------------------------------------------------
import { defaultClient } from "@api/client";
//------------------------------------------------------------------------------
// Requests --------------------------------------------------------------------
export const vehicleSearch = ({ searchQuery: query }) => {
  return defaultClient.get("/vehicle/search", { params: { query } });
};
